<!--
 * @Author: wangwei
 * @Date: 2021-01-04 14:37:27
 * @LastEditTime: 2021-01-13 14:43:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /java-pc/src/views/member/order/Evaluate.vue
-->
<template>
  <div class="sld_order_evaluatist">
    <!-- <MemberTitle :memberTitle="L['交易评价/晒单']"></MemberTitle> -->
    <div class="title">
      <span v-if="currentPage === 'comList'">{{ L['评价管理'] }}</span>
      <span v-else-if="currentPage === 'comments'">{{ L['评价订单'] }}</span>
      <span v-else-if="currentPage === 'comDetail'">{{ L['评价详情'] }}</span>
    </div>
    <!-- <div class="top_info flex_row_start_center">
      <div class="left flex_column_center_center">
        <div class="evaluating">
          <div>{{ L['待评订单'] }}</div>
          <span class="num">{{ member_info.data.toEvaluateOrder }}</span>
        </div>
        <span class="text">{{ L['发评价，得积分，积少成多换商品'] }}</span>
      </div>
      <div class="right flex_row_between_start">
        <div class="info">
          <div class="flex_row_start_center">
            <img class="tips" :src="tips" alt="" />
            <p>{{ L['评价小贴士'] }}</p>
          </div>
          <div class="flex_row_center_center">
            <span class="tips_info">{{ L['发表评价可获得会员积分'] }}</span>
          </div>
        </div>
        <div class="qrcode">
          <div class="image">
            <img :src="logo" alt />
          </div>
        </div>
      </div>
    </div> -->
    <div v-if="currentPage === 'comList'" class="evaluatilist_con" >
      <div class="title" style="margin-bottom: 0px;">
        <div :class="['evaluating', { active: currentTab === 'unComments' }]"  
          @click="switchTab('unComments')" >{{ L['待评价'] }} 
          <span class="eva_num">{{ wait_comments_list.total }}</span> 
        </div>
        <div :class="['evaluating', { active: currentTab === 'myComments' }]"  
          @click="switchTab('myComments')">{{ L['已评价/追评'] }} 
          <span class="eva_num">{{ comments_list.total }}</span> 
        </div>
      </div>
      <!-- 待评价 -->
      <div class="eva_container" v-if="currentTab === 'unComments'">
        <div class="order_item" v-for="(orderItem, index) in wait_comments_list.data" :key="index">
              <!-- <div class="order_item_title flex">
                <span class="order_sn">{{
                  orderItem.createTime
                }}<span @click="goOrderDetail(orderItem.orderSn)">{{ L['订单号'] }}：{{ orderItem.orderSn }}</span></span>
                <span class="price">{{ L['金额'] }}</span>
                <span class="oprate">{{ L['操作'] }}</span>
              </div> -->
              <div class="unCom_container flex_row_start_center">
                <div class="image" @click="goGoodsDetail(orderItem.productId)">
                  <coverImage :src="orderItem.productImage" width="120" height="120"></coverImage>
                </div>
                <div class="name" @click="goGoodsDetail(orderItem.productId)">
                  {{ orderItem.productShortTitle }}
                </div>
                <div class="eva_btn" @click="goEvaluationCenter(orderItem)">立即评价</div>
              </div>
              
              <!-- <div class="oprate flex_column_center_center">
                <span class="detail pointer" @click="goOrderDetail(orderItem.orderSn)">{{ L['订单详情'] }}</span>
                <div class="evaluate_btn pointer" @click="goOrderEvaluate(orderItem.orderSn)">
                  {{ L['评价订单'] }}
                </div>
              </div> -->
              <!-- <div class="good_info flex_row_start_center">
                <div class="good_con flex_column_center_center">
                  <div class="good_item flex_row_center_center" v-for="(goodItem, index) in orderItem.orderProductListVOList"
                    :key="index">
                    <div class="image flex_row_center_center" @click="goGoodsDetail(goodItem.productId)">
                      <coverImage :src="goodItem.productImage" width="80" height="80"></coverImage>
                    </div>
                    <div class="name overflow_ellipsis_two" @click="goGoodsDetail(goodItem.productId)">
                      {{ goodItem.goodsName }}
                    </div>
                    <span class="num">x{{ goodItem.productNum }}</span>
                  </div>
                </div>
                <div class="price flex_row_center_center">
                  {{ L['支付金额'] }}：¥{{ orderItem.orderAmount }}
                </div>
                <div class="oprate flex_column_center_center">
                  <span class="detail pointer" @click="goOrderDetail(orderItem.orderSn)">{{ L['订单详情'] }}</span>
                  <div class="evaluate_btn pointer" @click="goOrderEvaluate(orderItem.orderSn)">
                    {{ L['评价订单'] }}
                  </div>
                </div>
              </div> -->
            </div>
            <div class="empty" v-if="wait_comments_list.data.length == 0" >
              <img src="@/assets/acode_empty.png" alt="">
              <div>暂无数据哦</div>
            </div>
            <!-- <SldCommonEmpty v-if="wait_comments_list.data.length == 0" :tip="L['暂无订单～']" totalWidth="934px" /> -->
      </div>
      <!-- 已评价 -->
       <div class="eva_container" style="padding: 50px;" v-else>
          <div class="eva_item" v-for="(evaItem, index) in  comments_list.data" :key="index">
            <div class="eva_con flex_column_start_start">
              <div class="com_container_top flex_row_start_center">
                <div class="image" @click="goGoodsDetail(evaItem.productId)">
                  <coverImage :src="evaItem.productPic" width="76" height="76"></coverImage>
                </div>
                <div class="name_star_con flex_column_start_start">
                  <div style="margin-bottom: 8px;" class="flex_row_start_center">
                    <!-- {{ evaItem.star }} -->
               
                    <el-rate
                    :model-value="evaItem.star"
                      :max="5"
                      disabled
                      :colors="['#red', '#yellow', '#red']"
                      />
                    <!-- </el-rate> -->
                    <span class="self" v-if="evaItem.isHide == 1">已匿名</span>
                  </div>
                  <div class="flex_row_start_center">
                    <div class="pic_wait" v-if="evaItem.isCheck == 1">
                      审核中
                    </div>
                    <div class="name" @click="goGoodsDetail(evaItem.productId)">
                      {{ evaItem.goodsName }}
                    </div>
                  </div>
                  
                </div>
                <div class="btn_con flex_row_start_center">
                  <div class="eva_btn" v-if="evaItem.addtionalFlag == 0" @click="getEvaDetails(evaItem.commentId)">追评</div>
                  <div class="white_btn" @click="getEvaDetails(evaItem.commentId)">查看评价</div>
                  <div class="white_btn" @click="openDelBox(evaItem)">删除评价</div>
                </div>
              </div>
              <!-- 我的评价 -->
              <div class="com_container_center flex_row_start_start">
                <span class="eva_my_title">我的评价：</span>
                <div class="fle_column_start_start">
                  <span class="eva_my_content" >{{ evaItem.content }}</span>
                  <div v-if="evaItem.images != null" class="img_container">
                    <div v-for="(imgItem,imgIndex) in evaItem.images" :key="imgIndex">
                        <img class="img_my" :src="{imgItem}" alt="">
                    </div>
                  </div>
                </div>
              </div>
              <!-- 商家回复 -->
              <div v-if="evaItem.replyContent" class="com_container_center flex_row_start_start" style="border-top: 1px solid #EAEDF0;">
                <span class="eva_my_title">商家回复：</span>
                <div class="fle_column_start_start">
                  <span class="eva_my_content">{{ evaItem.replyContent }}</span>
                </div>
              </div>
            </div>
            
          <!-- <div class="order_item_title flex">
            <span class="order_sn">{{
              orderItem.createTime
            }}<span @click="goOrderDetail(orderItem.orderSn)">{{ L['订单号'] }}：{{ orderItem.orderSn }}</span></span>
            <span class="price">{{ L['金额'] }}</span>
            <span class="oprate">{{ L['操作'] }}</span>
          </div> -->
          <!-- <div class="good_info flex_row_start_center">
            <div class="good_con flex_column_center_center">
              <div class="good_item flex_row_center_center" v-for="(goodItem, index) in orderItem.orderProductListVOList"
                :key="index">
                <div class="image flex_row_center_center" @click="goGoodsDetail(goodItem.productId)">
                  <coverImage :src="goodItem.productImage" width="80" height="80"></coverImage>
                </div>
                <div class="name overflow_ellipsis_two" @click="goGoodsDetail(goodItem.productId)">
                  {{ goodItem.goodsName }}
                </div>
                <span class="num">x{{ goodItem.productNum }}</span>
              </div>
            </div>
            <div class="price flex_row_center_center">
              {{ L['支付金额'] }}：¥{{ orderItem.orderAmount }}
            </div>
            <div class="oprate flex_column_center_center">
              <span class="detail pointer" @click="goOrderDetail(orderItem.orderSn)">{{ L['订单详情'] }}</span>
              <div class="evaluate_btn pointer" @click="goOrderEvaluate(orderItem.orderSn)">
                {{ L['评价订单'] }}
              </div>
            </div>
          </div> -->
        </div>
        <div class="empty" v-if=" comments_list.data.length == 0" >
          <img src="@/assets/acode_empty.png" alt="">
          <div>暂无数据哦</div>
        </div>
        <!-- <SldCommonEmpty v-if=" comments_list.data.length == 0" :tip="L['暂无订单～']" totalWidth="934px" /> -->
       </div>
      
      <!-- 分页 start -->
      <div class="flex_row_center_center sld_pagination">
        <el-pagination 
        @current-change="handleCurrentChange" 
        :currentPage="pageData.current"
          :page-size="pageData.pageSize" 
          layout="prev, pager, next" 
          :total="pageData.total"
          background
          :hide-on-single-page="true">
        </el-pagination>
      </div>
      <!-- 分页 end -->
    </div>

    <!-- 当currentPage为'comments'时显示立即评价页面 -->
    <div v-else-if="currentPage === 'comments'" class="evaluation_center_con">
      <div class="eva_detial_top flex_row_start_center">
          <img class="pro_img" :src="selectedOrder.productImage" alt="">
          <div class="pro_detail flex_column_center_center">
            <span class="pro_name">{{ selectedOrder.goodsName }}</span>
            <!-- <span class="pro_spec">{{ selectedOrder.specValues }}</span> -->
          </div>
       </div>
      <!-- 评价 -->
      <div class="unAdd felx_column_start_start">
        <div class="flex_row_start_start">
          <span class="add_eva_title" style="margin-right: 15px;">商品评价</span>
          <div class="flex_row_start_center">
            <el-rate 
              v-model="valueStar"
              :size = '19'
              @change="handleChange()"
             
              >
            </el-rate>
            <p :style="{color: rateTexts[valueStar] ? '#000000' : '#BDBDBD'}" class="start_nn">{{valueStar === 0 ? '点评' :rateTexts[valueStar]}}</p>
          </div>
        </div>
        
        <textarea 
          v-model="addComment"
          class="add_content" 
          :placeholder="L['展开说说对商品的想法吧～']"
          maxlength="300"
          style="
            width: 1046px;
            height: 150px;
            border-radius: 1px;
            border: 1px solid #E0E0E0;
            padding: 15px 25px;
            font-weight: 400;
            font-size: 15px;
            color: #000000;
            opacity: 0.7;
            line-height: 24px;
            resize: none; /* 禁止用户调整大小 */
            overflow-y: auto; /* 当内容超出时显示滚动条 */
          "
        ></textarea>
        <div class="add_bottom flex_row_start_start">
                <!-- 已选择的图片和视频预览 -->
            <div class="media_preview" style="overflow-y: hidden;">
              <div v-for="(media, indexM) in addImgList" :key="'img-' + indexM" 
              @mouseover="showDeleteIcon(indexM)" @mouseout="hideDeleteIcon()"
              class="media_item">
                <transition name="fade">
                  <div v-if="hoverIndex === indexM" class="delete_overlay">
                    <span class="delete_text" @click="delMedia(addImgList, indexM)">删除</span>
                  </div>
                </transition>
                <div class="img_item" :style="{ backgroundImage: 'url(' + media.url + ')' }"></div>
              </div>
              <div v-for="(video, indexV) in addVideoList" :key="'video-' + indexV" 
              @mouseover="showDeleteIconB(indexV)" @mouseout="hideDeleteIconB()"
              class="media_item">
                <transition name="fade">
                  <div v-if="hoverIndexB === indexV" class="delete_overlay">
                    <span class="delete_text" @click="delMedia(addVideoList, indexV)">删除</span>
                  </div>
                </transition>
                <video  :src="video.url" controls class="media_thumbnail"></video>
              </div>
            </div>

          <div
          v-if="canShowUploadBoxcom"
          @click="openFileSelector()" class="up_img_container flex_column_center_center">
            <div style="font-size: 16px;">+</div>
            <div class="bb">上传</div>
            <div class="bb">图片/视频</div>
            <input 
              type="file" 
              accept="image/*,video/*" 
              multiple 
              ref="fileInput" 
              @change="selectMediaCom($event)" 
              style="display:none;"
            />
          </div>
          <div class="img_num">{{ addImgList.length + addVideoList.length }}/9</div>
          <div class="flex_row_start_center" style="margin-left: auto;">
            <div class="custom-checkbox-wrapper">
              <el-checkbox v-model="isHide" class="custom-checkbox">{{ L['匿名评价'] }}</el-checkbox>
            </div>
            <div class="add_btn" @click="submitComment(selectedOrder)">提交</div>
          </div>
         
        </div>
      </div>
       
    </div>

    <!-- 当currentPage为'comDetail'时显示评价详情界面 -->
    <div v-else-if="currentPage === 'comDetail'" class="evaluation_detail_con">
      <!-- 评价详情界面的内容 -->
       <div class="eva_detial_top flex_row_start_center">
          <img class="pro_img" :src="commentDetailList.data.productPic" alt="">
          <div class="pro_detail flex_column_center_center">
            <span class="pro_name">{{ commentDetailList.data.goodsName }}</span>
            <span class="pro_spec">{{ commentDetailList.data.specValues }}</span>
          </div>
       </div>
       
       <div :style="commentDetailList.data.additionComment === null ? {} : { borderBottom: '1px solid #EAEDF0' }" 
        class="eva_detial_center fle_column_start_start">
        <div class="eva_star_content flex_row_start_center">
          <el-rate
          class="rate_rate"
            v-model="commentDetailList.data.star"
            :max="5"
            disabled>
          </el-rate>
          <span class="eva_tip" style="margin-left: 0px;">{{rateTexts[commentDetailList.data.star]}}</span>
          <span class="eva_time" :style="commentDetailList.data.additionComment === null ? {} : { marginLeft: 'auto' }">{{formatTimestamp(commentDetailList.data.createTime)}}</span>
        </div>
        <span class="eva_my_content" style="margin-bottom: 0px;">{{ commentDetailList.data.content }}</span>
        <div v-if="commentDetailList.data && (commentDetailList.data.images.length || commentDetailList.data.videos.length)" class="img_vedio flex_row_start_center">
          <div v-if="commentDetailList.data.images.length  " class="img_container">
            <div v-for="(imgItem,imgIndex) in commentDetailList.data.images" :key="imgIndex">
                <img class="img_my" :src="imgItem" alt="">
            </div>
          </div>
          <div v-if="commentDetailList.data.videos.length " class="img_container">
            <div v-for="(videosItem,videosIndex) in commentDetailList.data.videos" :key="videosIndex">
                <video class="img_my" :src="videosItem"></video>
            </div>
          </div>
        </div>
         <!-- 商家回复 -->
         <div v-if="commentDetailList.data.replyContent"  
         class="com_container_center flex_column_start_start" style="border-top: 1px solid #EAEDF0;">
          <span class="eva_my_title">商家回复</span>
          <div class="fle_column_start_start">
            <span class="eva_my_content">{{ commentDetailList.data.replyContent }}</span>
          </div>
        </div>
       </div>
       <!-- 追评部分 -->
        <div v-if="commentDetailList.data.additionComment != null" class="eva_detial_bottom fle_column_start_start">
          <div class="flex_row_start_center" style="margin-bottom: 20px;">
            <span class="add_eva_day"> {{ getReviewTimeText(commentDetailList.data.createTime, commentDetailList.data.additionComment.createTime) }}</span>
            <span class="add_eva_time">{{formatTimestamp(commentDetailList.data.additionComment.createTime)}}</span>
          </div>
          <div class="add_eva_content">{{ commentDetailList.data.additionComment.content }}</div>
          <div v-if="commentDetailList.data.additionComment.images.length || commentDetailList.data.additionComment.videos.length " class="img_vedio flex_row_start_center">
          <div v-if="commentDetailList.data.additionComment.images.length" class="img_container">
            <div v-for="(imgItem,imgIndex) in commentDetailList.data.additionComment.images" :key="imgIndex">
                <img class="img_my" :src="imgItem" alt="">
            </div>
          </div>
          <div v-if="commentDetailList.data.additionComment.videos.length " class="img_container">
            <div v-for="(videosItem,videosIndex) in commentDetailList.data.additionComment.videos" :key="videosIndex">
                <video class="img_my" :src="videosItem"></video>
            </div>
          </div>
        </div>
        </div>
        <!-- 未追评 -->
         <div v-if="!commentDetailList.data.additionComment" class="unAdd felx_column_start_start">
          <span class="add_eva_title">追加评价</span>
          <!-- <div class="add_content">展开说说对商品的想法吧～</div> -->
          <textarea 
            v-model="additionalComment"
            class="add_content" 
            :placeholder="L['展开说说对商品的想法吧～']"
            maxlength="300"
            style="
              width: 1046px;
              height: 150px;
              border-radius: 1px;
              border: 1px solid #E0E0E0;
              padding: 15px 25px;
              font-weight: 400;
              font-size: 15px;
              color: #000000;
              opacity: 0.7;
              line-height: 24px;
              resize: none; /* 禁止用户调整大小 */
              overflow-y: auto; /* 当内容超出时显示滚动条 */
            "
          ></textarea>
          <div class="add_bottom flex_row_start_start">
                  <!-- 已选择的图片和视频预览 -->
              <div v-if="additionImgList.length || additionVideoList.length" class="media_preview" style="overflow-y: hidden;">
                <div v-for="(media, indexA) in additionImgList" :key="'img-' + indexA" 
                @mouseover="showDeleteIcon(indexA)" @mouseout="hideDeleteIcon()"
                class="media_item">
                  <!-- <span class="close_icon" @click="delMedia(additionImgList, index)">
                    <img src="@/assets/order/close.png" alt="" />
                  </span> -->
                  <transition name="fade">
                    <div v-if="hoverIndex === indexA" class="delete_overlay">
                      <span class="delete_text" @click="delMedia(additionImgList, indexA)">删除</span>
                    </div>
                  </transition>
                  <div class="img_item" :style="{ backgroundImage: 'url(' + media.url + ')' }"></div>
                </div>
                <div v-for="(video, indexB) in additionVideoList" :key="'video-' + indexB" 
                @mouseover="showDeleteIconB(indexB)" @mouseout="hideDeleteIconB()"
                class="media_item">
                  <transition name="fade">
                    <div v-if="hoverIndexB === indexB" class="delete_overlay">
                      <span class="delete_text" @click="delMedia(additionVideoList, indexB)">删除</span>
                    </div>
                  </transition>
                  <!-- <span class="close_icon" @click="delMedia(additionVideoList, index)">
                    <img src="@/assets/order/close.png" alt="" />
                  </span> -->
                  <video :src="video.url" controls class="media_thumbnail"></video>
                </div>
              </div>

            <div
            v-if="canShowUploadBox"
            @click="openFileSelector()" class="up_img_container flex_column_center_center">
              <div style="font-size: 16px;">+</div>
              <div class="bb">上传</div>
              <div class="bb">图片/视频</div>
              <input 
                type="file" 
                accept="image/*,video/*" 
                multiple 
                ref="fileInput" 
                @change="selectMedia($event)" 
                style="display:none;"
              />
            </div>
            <div class="img_num">{{ additionImgList.length + additionVideoList.length }}/9</div>
            <div class="add_btn" @click="submitAdditionalComment(commentDetailList.data.commentId)">提交</div>
          </div>

        
         </div>

       

    </div>

     <!-- 删除弹框 -->
     <el-dialog v-model="delComments" title="选择删除原因" width="950px" center custom-class="spec_more_custom">
      <div class="alert_container flex_row_start_center">
        <img class="alert_icon" src="../../../assets/alert_del.png" alt="">      
        <span class="spec_title">{{ L['删除后不可恢复、不可重新评价，请谨慎操作！'] }}</span>
      </div>
      
            <div class="spec_main_container">
                <div class="spec_container">
                  <div class="spec_item_row pointer" v-for="(SpecInfoItem,SpecInfoIndex) in delReasonList" 
                  :key="SpecInfoIndex"
                  @click="chooseSpec(SpecInfoItem)"
                  :class="[
                    {'selected-item': isSpecSelected(SpecInfoItem)},
                    { 'last-in-row': isLastInRow(SpecInfoIndex) }
                  ]">
                    <div class="spec_item flex_row_center_center">
                      <span class="spec_name">{{ SpecInfoItem.content}}</span>
                    </div>
                  </div>
                </div>
            </div>
            
            <template #footer>
              <div class="dialog-footer">
                <el-button 
                
                :style="{opacity: selectedSpec ? '1' : '0.5'}" type="primary" 
                
                @click="selectedSpec ? delCommentsMe() : ''">{{ L['确定'] }}</el-button>
              </div>
            </template>
		    </el-dialog>
  </div>
</template>

<script>
import { reactive, getCurrentInstance, onMounted,ref,watch ,computed,onUnmounted} from 'vue'
import { ElRate,ElDialog, ElInput,ElMessage ,ElCheckbox} from 'element-plus'
import { useRouter } from 'vue-router'
import axios from 'axios'
import SldCommonEmpty from '../../../components/SldCommonEmpty'
import MemberTitle from '../../../components/MemberTitle'
import { apiUrl } from '../../../utils/config'
export default {
  name: 'OrderEvaluationList',
  components: {
    SldCommonEmpty,
    MemberTitle,
    ElRate,
    ElInput,
    ElCheckbox,
    ElMessage,
    ElDialog,

  },
  setup() {
    const additionalComment = ref('')//追评的内容
    const additionImgList = ref([])//追评的图片列表
    const additionVideoList = ref([])//追评的视频列表
    const addComment = ref('')//评价的内容
    const addImgList = ref([])//评价的图片列表
    const addVideoList = ref([])//评价的视频列表
    const isHide = ref(false) //是否匿名
    const selectedOrder = ref(null); // 当前选中的订单信息
    const delComments = ref(false);
    const currentCommentId = ref(null)
    const valueStar = ref(0); // 初始值为0星
    const rateTexts = ref( {
      1: '非常差',
      2: '差',
      3: '一般',
      4: '好',
      5: '非常好',
    })
    const fileInput = ref(null);
    const hoverIndex = ref(-1);
    const hoverIndexB = ref(-1);
    const pendingFilesCount = ref(0); // 新增：用于记录待处理的文件数量
    const member_info = reactive({ data: {} })
    const commentDetailList = reactive({ data: {images: [],videos: []} }) //评价详情列表
    const comments_list = reactive({ data: [], total: 0  })//已评价列表
    const wait_comments_list = reactive({ data: [], total: 0  }) //待评价列表
    const currentTab = ref('unComments') // 默认为待评价
    const logo = require('@/assets/order/evaluate_logo.png')
    const tips = require('@/assets/order/tips.png')
    const router = useRouter()
    const currentPage = ref('comList')  //控制当前页面：'comList'评价列表；'comments'立即评价；'comDetail'评价详情
    const pageData = reactive({
      current: 1,
      pageSize: 5,
      total: 0
    })
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()


    const delReasonList = ref([{
        content: "评论内容涉及隐私",
        createAdminId: 0,
        createTime: "2020-11-12 20:22:33",
        isInner: 1,
        isShow: 1,
        reasonId: 1,
        sort: 1,
        type: 0,
        value: "0",
        }, {
        content: "写错",
        createAdminId: 0,
        createTime: "2020-11-12 20:22:33",
        isInner: 1,
        isShow: 1,
        reasonId: 2,
        sort: 2,
        type: 0,
        value: "1",
        }, {
        content: "其它",
        createAdminId: 0,
        createTime: "2020-11-12 20:22:33",
        isInner: 1,
        isShow: 1,
        reasonId: 3,
        sort: 2,
        type: 0,
        value: "2",
         }],)
    // 计算属性用于获取当前选择的评分文本
    const selectedText = computed(() => {
      if (valueStar.value === 0) return '点评'; // 当评分为0时显示'点评'
      // 因为rateTexts从1开始，所以需要减去1来匹配索引
      return rateTexts[valueStar] || '';
    });
    const switchTab = (tab) => {
      if (currentTab.value !== tab) {
        currentTab.value = tab;
        pageData.current = 1; // 切换时重置到第一页
        if (tab === 'unComments') {
          getWaitEvaList(); // 获取待评价列表
        } else {
          getEvaList(); // 获取已评价列表
        }
      }
    }
    // 打开删除弹框
    const openDelBox =  (evaItem) => {
			delComments.value = true;
      currentCommentId.value = evaItem;
      console.log('弹框===========>')

			// try {
			
			// } catch (error) {
			
			// 	ElMessage.error("加载规格信息失败");
			// }
		};
    const selectedSpec = ref(null);

		// 选择或取消选择规格项
		function chooseSpec(SpecInfoItem) {
			// 更新选中状态
			selectedSpec.value = SpecInfoItem;
		}

		// 检查某个规格项是否被选中
		const isSpecSelected = computed(() => (SpecInfoItem) => {
			return selectedSpec.value === SpecInfoItem;
		});



// 是否可以显示上传框
    const canShowUploadBox = computed(
      () => additionImgList.value.length + additionVideoList.value.length < 9);

    const canShowUploadBoxcom = computed(
          () => addImgList.value.length + addVideoList.value.length < 9);

    // 打开文件选择器的方法
   const openFileSelector = () => {
      if (currentPage.value === 'comDetail') {
        if (canShowUploadBox.value) {
          fileInput.value.click();
        }
      } else if (currentPage.value === 'comments') {
        if (canShowUploadBoxcom.value) {
          fileInput.value.click();
        }
      }
    };

    // 处理文件选择变化
    const selectMedia = (event) => {
      const files = event.target.files;
      let allowedFilesCount = Math.min(files.length, 9 - (additionImgList.value.length + additionVideoList.value.length));
      
      for (let i = 0; i < allowedFilesCount; i++) {
        const file = files[i];
        //自动判断来源类型
        const sourceType = file.type.startsWith('video') ? 'evaluateVideo' : 'evaluate';
        const reader = new FileReader();
        reader.onload = function(e) {
          uploadMedia(file, e.target.result,sourceType);
        };
        reader.readAsDataURL(file);
      }

      if (allowedFilesCount < files.length) {
        alert(`最多上传9个文件，您已选择了${files.length}个`);
      }
    };

    // 上传媒体文件
    const uploadMedia = async (file, previewUrl,sourceType = 'evaluate') => {
      let data = new FormData();
      data.append('file', file);
      data.append('source', sourceType);
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + localStorage.getItem('access_token')
        }
      };
       let url = apiUrl + 'v3/oss/front/upload'
      try {
        const res = await axios.post(url, data, config);
        if (res.status === 200) {
          if (file.type.startsWith('image')) {
            additionImgList.value.push({ url: res.data.data.url });
          } else if (file.type.startsWith('video')) {
            additionVideoList.value.push({ url: res.data.data.url });
          }
          // 强制重新计算canShowUploadBox以确保UI更新
          canShowUploadBox.value; // 这行实际上不会做任何事情，因为它是只读的，但Vue会自动处理响应式更新
          
        } else {
          ElMessage.warning(L['上传失败']);
        }
      } catch (error) {
        ElMessage.warning(L['上传失败']);
      }
    };

     // 处理文件选择变化
     const selectMediaCom = (event) => {
      const files = event.target.files;
      let allowedFilesCount = Math.min(files.length, 9 - (addImgList.value.length + addVideoList.value.length));
      
      for (let i = 0; i < allowedFilesCount; i++) {
        const file = files[i];
        //自动判断来源类型
        const sourceType = file.type.startsWith('video') ? 'evaluateVideo' : 'evaluate';
        const reader = new FileReader();
        reader.onload = function(e) {
          uploadMediaCom(file, e.target.result,sourceType);
        };
        reader.readAsDataURL(file);
      }

      if (allowedFilesCount < files.length) {
        alert(`最多上传9个文件，您已选择了${files.length}个`);
      }
    };

    // 上传媒体文件
    const uploadMediaCom = async (file, previewUrl,sourceType = 'evaluate') => {
      let data = new FormData();
      data.append('file', file);
      data.append('source', sourceType);
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + localStorage.getItem('access_token')
        }
      };
       let url = apiUrl + 'v3/oss/front/upload'
      try {
        const res = await axios.post(url, data, config);
        if (res.status === 200) {
          if (file.type.startsWith('image')) {
            addImgList.value.push({ url: res.data.data.url });
          } else if (file.type.startsWith('video')) {
            addVideoList.value.push({ url: res.data.data.url });
          }
          // 强制重新计算canShowUploadBox以确保UI更新
          
          canShowUploadBoxcom.value;
        } else {
          ElMessage.warning(L['上传失败']);
        }
      } catch (error) {
        ElMessage.warning(L['上传失败']);
      }
    };

        // 删除媒体文件
      const delMedia = (list, index) => {
        list.splice(index, 1);
      };

      // 显示删除图标
      const showDeleteIcon = (index) => {
        hoverIndex.value = index;
      };

      // 隐藏删除图标
      const hideDeleteIcon = () => {
        hoverIndex.value = -1;
      };
            // 显示删除图标
      const showDeleteIconB = (index) => {
        hoverIndexB.value = index;
      };

      // 隐藏删除图标
      const hideDeleteIconB = () => {
        hoverIndexB.value = -1;
      };

      // 提交评价
      const submitComment = async (selectedOrder) => {
        if (valueStar.value == 0) {
          ElMessage(L['请填写星级评价']);
          return;
        }

        
        // 构建请求参数
        let param = {
          content: addComment.value, 
          createdAt: Math.floor(Date.now() / 1000),
          imgStr: addImgList.value.map(item => item.url).join(','), 
          isPic: addImgList.value.length > 0 ? 1 : 0,
          isVideo: addVideoList.value.length > 0 ? 1 : 0,
          videoStr: addVideoList.value.map(item => item.url).join(','), 
          isHide:isHide.value ? 1 : 0,
          orderProductId:selectedOrder.orderProductId,
          goodsId:selectedOrder.goodsId,
          orderSn:selectedOrder.orderSn,
          productId:selectedOrder.productId,
          star: valueStar.value
        };
        
        // console.log('追评内容:', addComment.value);
        // console.log('orderProductId:', selectedOrder.orderProductId);
        // console.log('图片列表:', addImgList.value.map(item => item.url).join(','));
        // console.log('isHide:', isHide.value ? 1 : 0);
        // console.log('valueStar:', valueStar.value);
        // return
        let config = {
          headers: {
            "Content-Type": "application/json",
            // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
          },
        };
        const riskCheckResult = await riskExamine(param.content);
        if (riskCheckResult === true) { // 如果风控检测通过
            // 调用更新信息接口
            proxy.$post('v3/business/front/orderComment/addComment', param, config).then(res => {
            if (res.state == 200) {
              ElMessage.success(L['提交成功']); // 成功消息提示
              currentPage.value = 'comList';
              getEvaList();
              getWaitEvaList();
            } else {
              ElMessage.error(res.msg); // 错误消息提示
            }
          })
          } else {
            // 如果风控检测未通过，则显示警告消息
            ElMessage({
              message: '评价内容包含敏感词请修改后提交',
              center: true,
              type: 'warning'
            });
          }
      };

     // 提交追加评价
      const submitAdditionalComment = async (commentId) => {
        if (!additionalComment.value.trim()) {
          alert(L['请填写追评内容']);
          return;
        }

        // 构建请求参数
        let param = {
          cid: '0',
          content: additionalComment.value, 
          createdAt: Math.floor(Date.now() / 1000),
          imgStr: additionImgList.value.map(item => item.url).join(','), 
          isAddtional: commentId,
          isPic: additionImgList.value.length > 0 ? 1 : 0,
          isVideo: additionVideoList.value.length > 0 ? 1 : 0,
          videoStr: additionVideoList.value.map(item => item.url).join(','), 
        };

        // console.log('追评内容:', additionalComment.value);
        // console.log('shijian:', Math.floor(Date.now() / 1000));
        // console.log('图片列表:', additionImgList.value.map(item => item.url).join(','));
        // console.log('图片列表:', additionImgList.value);
        // return
        let config = {
          headers: {
            "Content-Type": "application/json",
            // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
          },
        };
        const riskCheckResult = await riskExamine(param.content);
        if (riskCheckResult === true) { // 如果风控检测通过
            // 调用更新信息接口
            proxy.$post('v3/business/front/orderComment/additionComment', param, config).then(res => {
            if (res.state == 200) {
              ElMessage.success(L['提交成功']); // 成功消息提示
              currentPage.value = 'comList';
              getEvaList();
              getWaitEvaList();
            } else {
              ElMessage.error(res.msg); // 错误消息提示
            }
          })
          } else {
            // 如果风控检测未通过，则显示警告消息
            ElMessage({
              message: '评价内容包含敏感词请修改后提交',
              center: true,
              type: 'warning'
            });
          }
      };

      //评价中心
      const goEvaluationCenter = (orderItem) =>{
        selectedOrder.value = orderItem
        currentPage.value = 'comments';
        window.history.pushState({ page: 'comments' }, '', ''); // 添加历史记录
      }


    const getInfo = () => {
      proxy
        .$get('v3/member/front/member/getInfo')
        .then(res => {
          if (res.state == 200) {
            member_info.data = res.data
            console.log('ooooooo------->',member_info.data)
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }
    //去商品详情页
    const goGoodsDetail = productId => {
      proxy.$goGoodsDetail(productId)
    }

    //已评价列表
    const getEvaList = () => {
      var param = {}
      // param.evaluateState = 1
      // param.orderState = 40
      param.current = pageData.current
      param.pageSize = pageData.pageSize
      // param.total = pageData.total
      let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };
      proxy
        .$post('v3/business/front/orderComment/myComments', param,config)
        .then(res => {
          if (res.state == 200) {
            comments_list.data = res.data.list
            comments_list.total = res.data.pagination.total
            pageData.total = res.data.pagination.total
            // console.log('jjjjjj',comTotal)
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }

    //待评价列表
    const getWaitEvaList = () => {
      var param = {}
      // param.evaluateState = 1
      // param.orderState = 40
      param.current = pageData.current
      param.pageSize = pageData.pageSize
      // param.total = pageData.total
      let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };
      proxy
        .$post('v3/business/front/orderComment/unComments', param,config)
        .then(res => {
          if (res.state == 200) {
            wait_comments_list.data = res.data.list

            // console.log('kankan =========', wait_comments_list)
            wait_comments_list.total = res.data.pagination.total
            pageData.total = res.data.pagination.total
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }
    //删除评价
    const delCommentsMe = () => {
      if(!selectedSpec.value){
        ElMessage('请选择删除原因')
      }

      var param = {}
      // param.evaluateState = 1
      // param.orderState = 40
      param.commentId = currentCommentId.value.commentId,
      param.reason = selectedSpec.value.content || ''
      // param.total = pageData.total
      let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };
            // console.log('kankan ne -----?',selectedSpec.value.content)
            // console.log('selectedSpec-----?',selectedSpec.value)
            // console.log('commentId ne -----?',currentCommentId.value.commentId)
            // return
      proxy
        .$post('v3/business/front/orderComment/deleteComment', param,config)
        .then(res => {
          if (res.state == 200) {
            ElMessage.success(res.msg)
            delComments.value = false;
            getEvaList();
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }

    //评价详情
    const getEvaDetails = (commentId) => {
      currentPage.value = 'comDetail';
      window.history.pushState({ page: 'comments' }, '', ''); // 添加历史记录
      var param = {}
      // param.evaluateState = 1
      // param.orderState = 40
      param.commentId = commentId
      // param.total = pageData.total
      // let config = {
      //           headers: {
      //               "Content-Type": "application/json",
      //               // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
      //           },
      //       };
      proxy
        .$post('v3/business/front/orderComment/commentDetail', param)
        .then(res => {
          if (res.state == 200) {
            // ElMessage.success(res.msg)
            commentDetailList.data = res.data
            console.log('评价列表',commentDetailList.data)
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }

    const goOrderEvaluate = orderSn => {
      router.push({
        path: '/member/order/evaluate',
        query: {
          orderSn: orderSn
        }
      })
    }
    const goOrderDetail = orderSn => {
      router.push({
        path: '/member/order/detail',
        query: {
          orderSn: orderSn
        }
      })
    }
    //向前翻页
    const handlePrevCilickChange = () => {
      // if (pageData.current > 1) {
        pageData.current--;
        if (currentTab.value === 'unComments') {
          getWaitEvaList();
        } else {
          getEvaList();
        }
      // }
    }
    //向后翻页
    const handleNextCilickChange = () => {
      // if (pageData.current < Math.ceil(pageData.total / pageData.pageSize)) {
        pageData.current++;
        if (currentTab.value === 'unComments') {
          getWaitEvaList();
        } else {
          getEvaList();
        }
      // }
    }
    //页数改变
    const handleCurrentChange = current => {
      pageData.current = current
      if (currentTab.value === 'unComments') {
        getWaitEvaList();
      } else {
        getEvaList();
      }
    }
    const handleChange = (newVal) => {
      console.log('新评分:', newVal);
      console.log('valueStar:', valueStar.value);
      // 可以在这里处理新的评分值
    };

    const itemsPerRow = 2; // 假定每行两个优惠券
		const isLastInRow = (index) => {
			return (index + 1) % itemsPerRow === 0;
		}

    const formatTimestamp = (timestamp) => {
      if (!timestamp) return '';
      
      const ts = Number(timestamp);
      const date = ts > 9999999999 ? new Date(ts) : new Date(ts * 1000);
      
      if (isNaN(date.getTime())) return '';
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}`;
    };

    // 判断是否为同一天
    const isSameDay = (timestamp1, timestamp2) => {
      const date1 = new Date(Number(timestamp1) * 1000);
      const date2 = new Date(Number(timestamp2) * 1000);
      
      return date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
    };

    // 获取追评时间文本
    const getReviewTimeText = (startTimestamp, endTimestamp) => {
      if (isSameDay(startTimestamp, endTimestamp)) {
        return '当天追评';
      }
      
      const start = new Date(Number(startTimestamp) * 1000);
      const end = new Date(Number(endTimestamp) * 1000);
      
      // 计算毫秒差并转换为天数
      const diffTime = end - start;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      
      return `${diffDays}天后追评`;
    };

     // 监听浏览器的返回键
     const handlePopState = (event) => {
      if (event.state && event.state.page) {
        // 如果历史记录中有状态，则更新 currentPage
        currentPage.value = event.state.page;
      } else {
        // 如果没有状态，则默认返回评价列表页面
        currentPage.value = 'comList';
      }
    };

    // 组件挂载时添加事件监听
    // onMounted(() => {
    //   window.addEventListener('popstate', handlePopState);
    //   // 初始化时添加默认历史记录
    //   window.history.replaceState({ page: 'comList' }, '', '');
    // });

    // 组件卸载时移除事件监听
    onUnmounted(() => {
      window.removeEventListener('popstate', handlePopState);
    });

    
    onMounted(() => {
      getInfo()
      getWaitEvaList()
      getEvaList();
      window.addEventListener('popstate', handlePopState);
      // 初始化时添加默认历史记录
      window.history.replaceState({ page: 'comList' }, '', '');
    })


    const riskExamine = (content) => {
      return new Promise((resolve, reject) => {
        let params = {
          content: content,
          keyId: 0,
          memberId: '',
          riskType: 3,
          source: 2
        }
        let config = {
          headers: {
            "Content-Type": "application/json",
            // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
          },
        };
        proxy.$post('v3/system/front/risk/textRisk', params, config).then(res => {
          if (res.state == 200) {
            resolve(true); // 风控检测通过
          } else {
            resolve(false); // 风控检测未通过
          }
        }).catch(error => {
          reject(error); // 网络请求失败或其他异常
        });
      });
    }
    
    return {
      getInfo,
      switchTab,
      isLastInRow,
      itemsPerRow,
      handlePopState,
      formatTimestamp,
      getReviewTimeText,
      isSameDay,
      rateTexts,
      member_info,
      additionalComment,
      getEvaList,
      riskExamine,
      comments_list,
      wait_comments_list,
      goOrderEvaluate,
      goOrderDetail,
      pageData,
      selectedText,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      logo,
      tips,
      goGoodsDetail,
      getWaitEvaList,
      currentTab,
      L,
      delComments,
      openDelBox,
      currentPage,
      getEvaDetails,
      commentDetailList,
      delCommentsMe,
      additionImgList,
      additionVideoList,
      submitAdditionalComment,
      delMedia,
      uploadMedia,
      selectMedia,
      openFileSelector,
      fileInput,
      showDeleteIcon,
      hideDeleteIcon,
      showDeleteIconB,
      hideDeleteIconB,
      hoverIndex,
      hoverIndexB,
      canShowUploadBox,
      canShowUploadBoxcom,
      pendingFilesCount,
      goEvaluationCenter,
      selectedOrder,
      addComment,
      addImgList,
      addVideoList,
      isHide,
      submitComment,
      selectMediaCom,
      uploadMediaCom,
      valueStar,
      handleChange,
      delReasonList,
      selectedSpec,
      chooseSpec,
      isSpecSelected
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/member/orderEvaluation.scss';

.media_preview{
    // margin-top: 16px;
    display: flex;
    flex-wrap: nowrap; /* 确保子元素不会换行 */
    overflow-x: auto; /* 如果内容超出容器宽度，则显示水平滚动条 */
    object-fit: cover!important;
    .media_item {
        position: relative;
        // min-width: 60px; /* 设置最小宽度以避免过小 */
        // max-width: 60px; /* 设置最大宽度 */
        // max-height: 60px; /* 设置最大高度 */
        width: 60px; /* 设置最小宽度以避免过小 */
        height: 60px; /* 设置最大高度 */
        // background: pink;
        margin-right: 10px;
        .img_item{
            width: 60px;
            height: 60px;
        }
      }
}
.delete_overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(52,54,59,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  // color: white;
  // font-size: 14px;
  cursor: pointer;
  z-index: 33;
}

.delete_text {
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  line-height: 24px;
  text-align: center;
}

// .fade-enter-active, .fade-leave-active {
//   transition: opacity .5s;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
//   opacity: 0;
// }

.img_item, .media_thumbnail {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 0 200px 0;
  > img {
    width: 120px;
    height: 120px;
    -webkit-user-drag: none;
    // user-drag: none;
  }
  > div {
    margin-top: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 15px;
    color: #888e98;
    line-height: 24px;
  }
}
.pic_wait{
  width: 53px;
  height: 22px;
  background: #FFECEC;
  border-radius: 2px 2px 2px 2px;
  font-weight: 400;
  font-size: 15px;
  color: #EB5755;
  line-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}

/* 隐藏所有浏览器默认控件 */
video::-webkit-media-controls {
  display: none !important;
}

</style>
<style lang="scss">
.custom-checkbox-wrapper{
  font-weight: 400;
  font-size: 15px;
  color: #000000!important;
  line-height: 24px;
  margin-right: 30px;
}
.custom-checkbox .el-checkbox__label{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
/* 隐藏默认的复选框 */
.custom-checkbox .el-checkbox__input {
  display: none; /* 或者 visibility: hidden; 如果你希望保留空间 */
}

/* 自定义未选中状态的外观 */
.custom-checkbox .el-checkbox__label:before {
  content: '';
  display: inline-block;
  width: 14px; /* 根据图片大小调整 */
  height: 14px; /* 根据图片大小调整 */
  margin-right: 10px; /* 调整间距 */
  background: url('../../../assets/user/agree_no.png') no-repeat center center; /* 替换为你的未选中状态图片路径 */
  background-size: contain;
  cursor: pointer;
}

/* 自定义选中状态的外观 */
.custom-checkbox .el-checkbox__input.is-checked + .el-checkbox__label:before {
  background-image: url('../../../assets/user/agree_choose.png'); /* 替换为你的选中状态图片路径 */
  color: #000000!important;
}
.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #000000!important;
}

.el-checkbox {
    color:#000000!important;
    
}

.el-rate__icon.el-icon-star-on.el-rate__icon{
  font-size: 20px!important;
  // color: #1E7CFF!important;
  ::before{
    color: #1E7CFF;
  }
}

.el-rate__icon.el-icon-star-off.el-rate__icon{
  font-size: 20px!important;
  color: #888E98;
}
.el-rate__icon{
  color: #1E7CFF;
}
// .rate_rate.el-rate__item.el-rate__icon.el-icon-star-on.el-rate__icon {
//   color: #1E7CFF!important;
// }
.el-rate {
    // height: 24px!important;
    margin: 2px 15px 2px 0px;
    // margin-left: 15px;
}
.start_nn{
          font-weight: 400;
          font-size: 15px;
          // color: #BDBDBD;
          line-height: 24px;
      }
//       /* 自定义星星图标 */
// .custom-rate .el-rate__item .custom-star-empty {
//   font-size: 0!important; /* 移除默认图标 */
//   width: 24px; /* 调整大小以匹配你的图片尺寸 */
//   height: 24px;
//   background-image: url('../../../assets/star_empty.png'); /* 设置空心星星图片 */
//   background-size: cover;
//   background-repeat: no-repeat;
//   background-position: center;
// }

// .custom-rate .el-rate__item.is-active .custom-star-full {
//   font-size: 0!important; /* 移除默认图标 */
//   width: 24px; /* 调整大小以匹配你的图片尺寸 */
//   height: 24px;
//   background-image: url('../../../assets/star_fill.png'); /* 设置实心星星图片 */
//   background-size: cover;
//   background-repeat: no-repeat;
//   background-position: center;
// }

// /* 移除悬停时的动画 */
// .custom-rate .el-rate__item:hover .custom-star-empty,
// .custom-rate .el-rate__item:hover .custom-star-full {
//   transition: none!important;
// }


.spec_more_custom{
		width: 763px!important;
		height: 448px!important;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		background: #FFFFFF;
		box-shadow: 0px 8px 20px 0px rgba(0,0,0,0.15);
		border-radius: 0px 0px 0px 0px;
	}
.spec_more_custom .el-dialog__header{
	padding: 0px;
	height: 76px;
	padding-top: 50px;
}
.spec_more_custom .el-dialog__header .el-dialog__title{
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 500;
  font-size: 20px;
  color: #000000;
  line-height: 26px;
	margin-top: 50px;
}
.spec_more_custom .el-dialog__header .el-icon {
    --font-size: 26px; 
}
.spec_more_custom .el-dialog__body{
	// padding: 0px;
	padding: 30px 30px 0px;
	// padding-bottom: auto;
}
.spec_more_custom .el-dialog__footer{
	padding: 0px;
	margin-bottom: 20px;
	margin-top: auto;
}
.spec_more_custom .el-dialog__footer .el-button--primary{
	width: 150px;
	height: 46px;
	background: #1E7CFF!important;
	border-radius: 2px 2px 2px 2px;
	border: 1px solid #1E7CFF!important;
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 400;
	font-size: 18px;
	color: #FFFFFF;
	text-align: center;
	}
.alert_container{
  width: 703px;
  height: 46px;
  background: rgba(30,124,255,0.08);
  .alert_icon{
    width: 26px;
    height: 26px;
    margin-left: 17px;
  }
	.spec_title{
		font-family: Microsoft YaHei,Microsoft YaHei ;
		font-weight: 400;
    font-size: 15px;
    color: rgba(0,0,0,0.7);
    line-height: 22px;
		// margin-bottom: 20px;
	}

}
.spec_container{
		display: flex;
  	flex-wrap: wrap; /* 允许换行 */
		.spec_item_row{
				width: 341px;
				// height: 54px;
				border-radius: 1px 1px 1px 1px;
				margin-top: 20px;
				margin-right: 20px;
				border-radius: 1px 1px 1px 1px;
				
			.spec_item{
				width: 341px;
				// height: 54px;
				// border-radius: 1px 1px 1px 1px;
				// border: 1px solid #E0E0E0;
				border: 1px solid #E0E0E0;
				position: relative;
				padding: 17px 25px;
				display: flex;
				justify-content: center;
				align-items: center;
				text-align: center;
				height: 100%;
				.spec_name{
					font-family: Microsoft YaHei,Microsoft YaHei ;
					font-weight: 400;
          font-size: 15px;
          color: rgba(0,0,0,0.7);
          line-height: 22px;
          text-align: center;
				}
				
			}
		}
		.spec_item_row.last-in-row {
		margin-right: 0; /* 移除每行最后一个项目的右边距 */
	}
	.spec_item_row.selected-item{
		// .spec_item_row{
		// 	border: 1px solid #1E7CFF;
		// }
		.spec_item{
			border: 1px solid #1E7CFF;
		}
		.spec_name{
					color: #000000;
					
				}
	}
	}
  

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #FFFFFF!important;
    font-weight: 400!important;
    font-size: 13px!important;
    color: #1E7CFF!important;
    line-height: 28px!important;
    text-align: center!important;
    border: 1px solid #1E7CFF!important;
    border-radius: 0px!important;
}

.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    // margin: 0 5px;
    background-color: #FFFFFF!important;
    border: 1px solid #EAEDF0!important;
    font-weight: 400!important;
    font-size: 13px!important;
    color: #888E98!important;
    line-height: 28px!important;
    text-align: center!important;
    border-radius: 0px!important;
}
.el-icon {
    width: 28px!important;
   
}
</style>
